import Vue from 'vue';
import Router from 'vue-router';
import Purchase from 'views/purchase/index.vue';
import PcwBilling from 'views/purchase/billing/index.vue';
import Error from 'views/error/index.vue';
import Confirmation from 'views/confirmation/index.vue';
import store from './store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:productId',
      name: 'purchase',
      component: Purchase,
    },
    {
      path: '/:productId/billing',
      name: 'billing',
      component: PcwBilling,
      beforeEnter(to, from, next) {
        const { name } = from;
        if (name === 'purchase' || !name) {
          const globalQuotedTickets = store.getters['quote/globalQuotedTickets'];
          if (Object.entries(globalQuotedTickets).length > 0) {
            next();
          } else {
            next({ name: 'purchase' });
          }
        }
      },
    },
    {
      path: '/:productId/confirmation',
      name: 'confirmation',
      component: Confirmation,
      beforeEnter(to, from, next) {
        const { name } = from;
        if (name === 'recharge') {
          const confirmation = store.getters['order/rechargeConfirmation'];
          if (confirmation.length > 0) {
            next();
          } else {
            next({ name: 'recharge' });
          }
        } else if (name === 'billing') {
          const confirmation = store.getters['order/openEndedOrderData'];
          if (confirmation) {
            next();
          } else {
            next({ name: 'billing' });
          }
        } else {
          window.location = 'https://fanshield.com';
        }
      },
    },
    {
      path: '/:productId/error',
      name: 'error',
      component: Error,
    },
  ],
});
